import React from 'react';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';
import { useTheme } from '@mui/material';

interface IHighlightedTextProps {
  text: string;
  searchQuery: string;
  variant: Variant;
}

const HighlightedText = (props: IHighlightedTextProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const { searchQuery, text, variant } = props;

  const getHighlightedText = () => {
    if (!searchQuery) return text;

    // Split the search query on spaces or special characters like hyphens
    const queryWords = searchQuery.split(/[\s,.-]+/).filter(Boolean);
    const regex = new RegExp(`(${queryWords.join('|')})`, 'gi');

    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            textDecoration: `1px solid underline ${primaryColor}`,
            textUnderlineOffset: '2px'
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return <Typography variant={variant}>{getHighlightedText()}</Typography>;
};

export default HighlightedText;
